import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Footer,
  Page,
  RadioField,
  SavingIndicator,
  TextField,
} from '../../../components';
import { useStore } from '../../../store';
import { UserRoleOptions } from '../../../store/constants/index';

export default observer(function CreateUserPage() {
  const { userStore } = useStore();
  const navigate = useNavigate();
  const [user] = useState(userStore.createUser());

  async function onSaveClick() {
    await user.save();
    navigate(`/users/${user.id}`);
  }

  return (
    <Page navigation="Create new user">
      <TextField
        autoFocus
        errorText={user.errors.email}
        label="Email"
        name="email"
        onBlur={user.handleBlur}
        onChange={user.handleChange}
        sx={{ display: 'block', mt: 0, width: 240 }}
        value={user.email}
      />
      <TextField
        errorText={user.errors.password}
        label="Password"
        name="password"
        onBlur={user.handleBlur}
        onChange={user.handleChange}
        sx={{ display: 'block', width: 240 }}
        value={user.password}
      />
      <RadioField
        errorText={user.errors.role}
        label="Role"
        name="role"
        onBlur={user.handleBlur}
        onChange={user.handleChange}
        options={UserRoleOptions}
        value={user.role}
      />

      <Footer>
        <Button
          disabled={user.hasErrors}
          disabledTooltip={user.allErrorsAsStrings}
          onClick={onSaveClick}
          type="primary"
        >
          Create user
        </Button>

        <SavingIndicator indicator={user.indicator} />
      </Footer>
    </Page>
  );
});
